var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMapPin = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.9999 10C20.9999 17 11.9999 23 11.9999 23C11.9999 23 2.99988 17 2.99988 10C2.99988 7.6131 3.94809 5.32391 5.63592 3.63608C7.32374 1.94826 9.61293 1.00005 11.9999 1.00005C14.3868 1.00005 16.676 1.94826 18.3638 3.63608C20.0517 5.32391 20.9999 7.6131 20.9999 10Z",
  stroke: "#5E6C84",
  strokeWidth: 1.99861,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9999 13.0001C13.6567 13.0001 14.9999 11.6569 14.9999 10.0001C14.9999 8.3432 13.6567 7.00005 11.9999 7.00005C10.343 7.00005 8.99988 8.3432 8.99988 10.0001C8.99988 11.6569 10.343 13.0001 11.9999 13.0001Z",
  stroke: "#5E6C84",
  strokeWidth: 1.99861,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMapPin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/map-pin.645010ce.svg";
export { ForwardRef as ReactComponent };